module.exports = __webpack_public_path__ + "img/ic_32_register_apple.2ca491d4.svg";